document.addEventListener('DOMContentLoaded', function () {
  const isDesktop = () => window.innerWidth >= 1024;

  document.querySelectorAll('details.header__megamenu-item').forEach((details) => {
    const summary = details.querySelector('summary');
    const submenu = details.querySelector('.header__submenu');

    if (!summary || !submenu) return;

    let hoverTimeout;

    // Open on hover
    summary.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      clearTimeout(hoverTimeout);
      details.setAttribute('open', true);
    });

    // Keep open when hovering submenu
    submenu.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      clearTimeout(hoverTimeout);
    });

    // Close when mouse leaves entire area
    details.addEventListener('mouseleave', () => {
      if (!isDesktop()) return;
      hoverTimeout = setTimeout(() => {
        details.removeAttribute('open');
      }, 150);
    });

    // Prevent click toggle
    summary.addEventListener('click', (e) => {
      if (isDesktop()) e.preventDefault();
    });
  });
});
